import React from 'react'
import Prop from '../componentes/Prop'
import { ICON_TYPES } from '../constantes/iconos.ts'
import styled from 'styled-components'
import foto from '../imagenes/equipo.jpeg'

const Equipo = () => {
    return (
        <>
            <Prop titulo='NUESTROS COLABORADORES' icono={ICON_TYPES.TEAM} />
            <Section>
                <Article color='primary'>
                    <img alt='equipo' src={foto} style={{ width: '80%', height: 'auto' }} />
                </Article>
            </Section>
            <Section>
                <Article color='secundary'>
                    <p>
                        Tenemos un equipo de administrativas, maestros y jovenes en servicio social, dando lo mejor por los niños que pertenecen a nuestra fundación
                    </p>
                </Article>
            </Section>
        </>
    )
}

const Section = styled.section`
    width: 100vw;
    height: max-content;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px;
`

const Article = styled.article`
    border-radius: 20px;
    width: 80%;
    height: max-content;
    background-color: var(--${props => props.color});
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    color: white;
`
export default Equipo